import NotificationBand from './NotificationBand';

export default NotificationBand;
